module.exports = "https://service.ai-x-supporter.com/dinos_faq/static/img/sai-icon_scroll.d9312c8.gif";


//////////////////
// WEBPACK FOOTER
// ./products/390/resource/sai-icon_scroll.gif
// module id = kT5y
// module chunks = 0